import styled from 'styled-components'
import { InputElement } from '../styles'

export const PlainInputElement = styled(InputElement)<{
  $hasIcon?: boolean
  $error?: boolean
}>`
  padding: 0px 10px;
  width: 100%;
  position: relative;
  padding-left: ${({ $hasIcon }) => $hasIcon && '40px'};
  border-color: ${({ theme, $error }) =>
    $error ? theme.red : theme.border} !important;
`

export const PlainInputIconContainer = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  left: 15px;
  z-index: 1;

  svg {
    color: ${({ theme }) => theme.secondary};
  }
`
